import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCookie } from "../../../utils/cookie";
import MethodsClass from "../../../utils/method";
import { getPageType, getPageUrl, getCookieId } from "../../utils";
import pkg from "../../../../package.json";
import { getPageIdInfo } from "../../../utils/common";
// 初始化 基础参数
export var initBase = function initBase() {
  var _navigator$connection, _getPageIdInfo;
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    backup: {}
  };
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var Methods = new MethodsClass();
  var version = pkg && pkg.version || '';
  var cookieid = getCookieId();
  var fromType = 'm';
  var clientType = Methods.getClientType();
  var ua = Methods.UA;
  var os = Methods.getOS();
  var isoffline = getCookie('isoffline') || 0;
  var isprerender = Methods.isPrerenderPage();
  var iszz = Methods.isZZ();
  var zzv = Methods.getZZV();
  var zzt = Methods.getZZT();
  var phoneType = Methods.getPhoneType();
  var netType = ((_navigator$connection = navigator['connection']) === null || _navigator$connection === void 0 ? void 0 : _navigator$connection.effectiveType) || '';
  var operatorType = '';
  var pageurl = getPageUrl({
    needScheme: true
  });
  var pagetype = getPageType();
  var actiontype = 'PERFORMANCE';
  var appid = 'ZHUANZHUAN';
  var abtesttype = 'ALL';
  var pageId = (_getPageIdInfo = getPageIdInfo()) === null || _getPageIdInfo === void 0 ? void 0 : _getPageIdInfo.pageId;
  Object.assign(params, {
    pagetype: (opts === null || opts === void 0 ? void 0 : opts.pagetype) || pagetype,
    actiontype: (opts === null || opts === void 0 ? void 0 : opts.actiontype) || actiontype,
    appid: (opts === null || opts === void 0 ? void 0 : opts.appid) || appid,
    abtesttype: (opts === null || opts === void 0 ? void 0 : opts.abtesttype) || abtesttype,
    os: os,
    ua: ua,
    backup: _objectSpread(_objectSpread({}, params.backup), {}, {
      pageid: (opts === null || opts === void 0 ? void 0 : opts.pageId) || pageId,
      pageurl: pageurl,
      fromType: (opts === null || opts === void 0 ? void 0 : opts.fromType) || fromType,
      version: version,
      isoffline: isoffline,
      // 是否离线包
      isprerender: isprerender,
      // 是否预渲染， 主动上报时设置
      zzv: zzv,
      zzt: zzt,
      phoneType: phoneType,
      isFirst: 1,
      iszz: iszz,
      clientType: (opts === null || opts === void 0 ? void 0 : opts.clientType) || clientType,
      netType: netType,
      operatorType: operatorType,
      cookieid: cookieid
    })
  });
  return params;
};